import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { Router, RouterModule } from '@angular/router';
import { Actions, TableColumn } from '@app/shared/table/TableColumn';
import { DataMappingService } from './data-mapping.service';
import { UtilService } from '@app/shared/services/util.service';
import { LoggerService } from '@app/shared/services/logger.service';
type OurAttr = { key: string; label: string;  displayName: string; optional?: boolean };

@Component({
    imports: [FormsModule, ReactiveFormsModule, SharedModule, RouterModule],
    selector: 'app-data-mapping',
    templateUrl: './data-mapping.component.html',
    styleUrls: ['./data-mapping.component.css']
})

export class DataMappingComponent{
  isLoading = false;
  serviceError: any;

  // Table Data
  editingMode: boolean = false;
  selectedRow: any;
  allMappings: any[] = [];
  rowActionList: Array<Actions> = [
      {
        iconName: 'edit',
        iconTooltip: 'Modify Mapping',
        name: 'edit',
      },
      {
        iconName: 'trash',
        iconTooltip: 'Delete Mapping',
        name: 'delete',
      },
      {
        iconName: 'archive',
        iconTooltip: 'Archive Mapping',
        name: 'archive',
      },
    ];
    tableColumns: Array<TableColumn> = [
      {
        name: 'S.No.',
        dataKey: 'sno',
        position: 'left',
        isSortable: true,
        type: 'text',
      },
      // {
      //   name: 'Mapping ID',
      //   dataKey: 'id',
      //   type: 'text',
      //   isSortable: true,
      // },
      {
        name: 'Mapping Name',
        dataKey: 'name',
        type: 'text',
        isSortable: true,
      },
      {
        name: 'Created By',
        dataKey: 'created_user_name',
        type: 'text',
        isSortable: true,
      },
      {
        name: 'Created On',
        dataKey: 'created_date',
        type: 'text',
        isSortable: true,
      },
      {
        name: 'Last Modified',
        dataKey: 'modified_date',
        type: 'text',
        isSortable: true,
      },
      {
        name: 'Status',
        dataKey: 'status',
        type: 'toogle',
        isFilterable: true,
        conditionalNaming: {
          '0': {
            name: 'Archived',
            checked: false,
            disabled: true,
          },
          '1': {
            name: 'Active',
            checked: true,
            disabled: false,
          },
          '2': {
            name: 'Inactive',
            checked: false,
            disabled: false,
          },
        },
      },
      {
        name: 'Actions',
        // type: 'actions',
        type: 'threeDotActions',

        rowActions: this.rowActionList,
      },
    ];
    tableActions: Array<Actions> = [
      {
        iconName: 'plus',
        iconTooltip: 'Add Mapping',
        name: 'add',
      },
    ];
    tableName: string = 'Data Mappings ';

    filterAttributes = [
      {
        dataKeyName: 'name',
        name: 'Mapping Name',
        type: 'text'
      },
      {
        dataKeyName: 'created_user_name',
        name: 'Created By',
        type: 'text'
      },
      {
        dataKeyName: 'all',
        name: 'All Text',
        type: 'all',
        data: ['dinesh123', 'dinesh12', 'Tag3', 'Tag4', 'Tag5', 'Tag6'],
      },
    ];
  
  // New property for mapping name
  mappingName: string = '';

  constructor(
    private route: Router,
    private service: DataMappingService,
    private util: UtilService,
    private logger: LoggerService,
    private cdr: ChangeDetectorRef
  ) { 
    this.setActiveModule(this.activeModule);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.getMappings();
  }

  updateStatus(event: any, status: string) {
    // Handle toggle event if needed
    this.isLoading = true;
    const row = event.row;
    let payload;
    if(status === 'active'){
      payload = {
        is_active: !row.is_active,
        is_deleted: row.is_deleted,
        is_archived: row.is_archived
      };
    }else if(status === 'archive'){
      payload = {
        is_active: row.is_active,
        is_deleted: row.is_deleted,
        is_archived: !row.is_archived
      };
    }else if(status === 'delete'){
      payload = {
        is_active: row.is_active,
        is_deleted: true,
        is_archived: row.is_archived
      };
    }

    this.service.updateStatusMapping(row.id, payload).subscribe(
      (data: any) => {
        const responseBody = data.body.responseBody;
        const successMsg = status==='delete'? 'Mapping deleted successfully.' : 'Status updated successfully.';
        this.util.simpleDialog({
          title: 'Success',
          message: successMsg,
        });
        this.getMappings();
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      (err) => {
        this.util.showLoader = false;
        this.util.simpleDialog({
          title: 'Error',
          message: err,
        });
        console.error('Error updating status:', err);
        this.logger.error('Error updating status:', err);
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  rowAction(event: any) {
    switch (event.rowName) {
      case 'edit':
        this.mappingName = event.row.name;
        this.mappings = event.row.mapping_config || {};
        this.setActiveModule('Courses');
        this.selectedRow = event.row;
        this.editingMode = true;
        ($('#AddMappingPopup') as any).modal('show');
        break;

      case 'delete':
        this.updateStatus(event, 'delete');
        break;

      case 'archive':
        this.updateStatus(event, 'archive');
        break;

      default:
        console.warn(`Unhandled row action: ${event.rowName}`);
        break;
    }
  }

  home() {
    this.route.navigate(['/'])
  }

  openMappingPopup() {
    ($('#AddMappingPopup') as any).modal('show');
  }

  closeMappingPopup() {
    this.mappingName = '';
    this.mappings = {};
    this.setActiveModule('Courses');
    this.editingMode = false;
    ($('#AddMappingPopup') as any).modal('hide');
  }

  modules = ['Courses', 'Questions', 'Question Papers', 'Assessments', 'Candidates'];

// Default selected module
activeModule: string = 'Courses';

// Fixed schema for our attributes per module
schema: Record<string, OurAttr[]> = {
  'Courses': [
    // { key: 'courseCode',          label: 'code',          displayName: 'Course/Job Code' },
    { key: 'courseName',          label: 'course_name',          displayName: 'Course/Job Role' },
    { key: 'courseVersionName',  label: 'course_version_name',  displayName: 'Course Version' },
  ],
  'Questions': [
    { key: 'questionText',         label: 'question_text',         displayName: 'Question Text' },
    { key: 'questionCategoryId', label: 'question_category', displayName: 'Evaluation Mode' }, // Changed from 'Category'
    { key: 'questionTypeId',     label: 'question_type',     displayName: 'Question Type (MCQ, Subjective, etc.)' },
    { key: 'difficultyLevelId',  label: 'difficulty_level',  displayName: 'Difficulty Level(Easy, Medium, Difficult)' },
    { key: 'optionData',          label: 'option_data',          displayName: 'Answer Options', optional: true },
    { key: 'kpiName',          label: 'kpi_name',          displayName: 'KPI Name', optional: true }, // Made optional
    { key: 'observationScore',          label: 'observation_score',          displayName: 'Observation Score', optional: true },
    { key: 'vivaScore',          label: 'viva_score',          displayName: 'Viva Score', optional: true }, // Made optional
  ],
  'Question Papers': [
    { key: 'courseName',          label: 'course_name',          displayName: 'Course/Job Role' },
    { key: 'courseVersionName',  label: 'course_version_name',  displayName: 'Course Version' },
    { key: 'questionPaperName', label: 'paper_name', displayName: 'Question Paper Title' },
    { key: 'shortName', label: 'short_name', displayName: 'Question Paper Short Name' },
    { key: 'countOfQuestions',  label: 'questions_count',  displayName: 'Count of Questions' },
    { key: 'timeLimit',  label: 'time_limit',  displayName: 'Time Limit' },
    { key: 'totalMarks',  label: 'total_marks',  displayName: 'Total Marks' },
    { key: 'questionPaperInstructions',  label: 'question_paper_instructions',  displayName: 'Question Paper Instructions' },
    { key: 'category',  label: 'category',  displayName: 'Category'},
    { key: 'questionGroupingLogic',  label: 'question_grouping_logic',  displayName: 'Question Grouping Logic'}
  ],
  'Assessments': [
    { key: 'title',              label: 'name',              displayName: 'Assessment Title' },
    { key: 'courseName',          label: 'course_name',          displayName: 'Course/Job Role' },
    { key: 'courseVersionName',  label: 'course_version_name',  displayName: 'Course Version' },
    { key: 'description',       label: 'description',       displayName: 'Assessment Description', optional: true }, // Made optional
    { key: 'instructions',      label: 'instructions',      displayName: 'Instructions for Candidates' },
    { key: 'questionPaperName', label: 'question_paper_name', displayName: 'Linked Question Paper' },
    { key: 'startDateTime',     label: 'start_datetime',     displayName: 'Start Date & Time' },
    { key: 'endDateTime',       label: 'end_datetime',       displayName: 'End Date & Time' },
  ],
  'Candidates': [
    { key: 'fullName',  label: 'name',  displayName: 'Candidate Full Name' },
    { key: 'email', label: 'email', displayName: 'Email Address', optional: true },  // Made optional
    { key: 'phone', label: 'phone', displayName: 'Phone Number', optional: true },   // Made optional
  ],
};


// Final mapping result: module -> ourAttrKey -> theirAttrString
mappings: { [module: string]: { [ourKey: string]: string } } = {};

setActiveModule(module: string) {
  this.activeModule = module;

  // Initialize mapping entries for this module if not present
  if (!this.mappings[module]) {
    this.mappings[module] = {};
  }

  // Ensure every our-attribute key exists (default to empty string)
  for (const attr of this.getOurAttributesForModule(module)) {
    if (this.mappings[module][attr.key] === undefined) {
      this.mappings[module][attr.key] = '';
    }
  }
}

getOurAttributesForModule(module: string | null): OurAttr[] {
  return module ? this.schema[module] ?? [] : [];
}

isModuleValid(module: string | null): boolean {
  if (!module) return false;
  const attrs = this.getOurAttributesForModule(module);
  for (const attr of attrs) {
    if (!attr.optional) {
      const v = (this.mappings[module][attr.key] || '').trim();
      if (!v) return false;
    }
  }
  return true;
}

getMappings() {
  this.service.getAllMapping().subscribe(
    (data: any) => {
      const responseBody = data.body.responseBody;
      this.allMappings = responseBody.map((item: any) => {
        item.status = item.is_archived ? '0' : item.is_active ? '1' : '2';
        return {...item};
      })
      this.isLoading = false;
      this.cdr.detectChanges();
    },
    (err) => {
      this.util.showLoader = false;
      this.util.simpleDialog({
        title: 'Error',
        message: err,
      });
      console.error('Error fetching mappings:', err);
      this.logger.error('Error fetching mappings:', err);
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  );
}

saveMappings() {
  this.isLoading = true;
  const payload = {
    mapping_name: this.mappingName,
    mapping_config: this.mappings,
  };
  if(this.editingMode) {
    payload['mapping_id'] = this.selectedRow?.id;
  }
  this.service.createMapping(payload).subscribe(
    (data: any) => {
      const responseHead = data.body.responseHead;
      const successMsg = responseHead
        ? this.util.getSuccessMessage(
          'UPDATE_DATA_MAPPING',
          responseHead.statusCode,
          responseHead.statusDesc
        )
        : responseHead;
      this.util.simpleDialog({
        title: 'Updated',
        message: successMsg,
      });
      this.closeMappingPopup();
      this.getMappings();
    },
    (err) => {
      this.isLoading = false;
      this.cdr.detectChanges();
      this.util.simpleDialog({
        title: 'Error',
        message: err,
      });
      console.error('Error updating mappings:', err);
      this.logger.error('Error updating mappings:', err);
    }
  );
}

}
